import { render } from "./LanguageSelector.vue?vue&type=template&id=541c2ec6&ts=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=541c2ec6&lang=scss&scope=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__